import Card from './card';
import styles from './card-unified.module.scss';
import classNames from 'classnames';

export type CardUnifiedProps = {
  imageUrl?: string;
  backgroundImageUrl?: string;
  backgroundColor?: string;
  title: string;
  subtitle?: string;
  footerLeft?: string;
  footerRight?: string;
  className?: string;
  isRewards?: boolean;
  buttonMode?: boolean;
  showHoverEffect?: boolean;
  onClick?: () => void;
};

const CardUnified = ({
  imageUrl,
  backgroundImageUrl,
  backgroundColor = '',
  title,
  subtitle,
  footerLeft,
  footerRight,
  className,
  isRewards,
  buttonMode = true,
  showHoverEffect = false,
  onClick = () => {},
}: CardUnifiedProps) => {
  const imageContainerStyle = {
    backgroundColor,
    backgroundImage: backgroundImageUrl && `url(${backgroundImageUrl})`,
  } as const;
  return (
    <button data-hook='wrapper' onClick={onClick} className={styles['wrapper']}>
      <Card
        noPadding
        className={classNames(
          className,
          styles.card,
          buttonMode && styles['card--button-mode'],
          showHoverEffect && styles['card--hover'],
        )}
      >
        <div
          data-hook='imageContainer'
          className={classNames(
            styles['image-container'],
            isRewards && styles['image-container--rewards'],
            !!backgroundImageUrl && styles['image-container--with-overlay'],
          )}
          style={imageContainerStyle}
        >
          {imageUrl && (
            <div className={styles['image-container__inner']}>
              <img
                alt=''
                src={imageUrl}
                className={classNames(
                  styles['main-image'],
                  isRewards && styles['main-image--rewards'],
                )}
              />
            </div>
          )}
        </div>
        <div data-hook='contentWrap' className={styles['content-wrap']}>
          <div data-hook='cardBody' className={styles[`card-body`]}>
            <div className={styles.title}>{title}</div>
            {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
          </div>
          <div data-hook='footerWrap' className={styles['footer-wrap']}>
            <div
              className={classNames(styles[`footer`], styles[`footer--left`])}
            >
              {footerLeft}
            </div>
            {footerRight && (
              <div
                className={classNames(
                  styles[`footer`],
                  styles[`footer--right`],
                )}
              >
                {footerRight}
              </div>
            )}
          </div>
        </div>
      </Card>
    </button>
  );
};

CardUnified.displayName = 'CardUnified';

export default CardUnified;
